import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "programPanel",
    "program",
    "programOptions",
    "enterCodeContainer", 
    "codeField"
  ];

  connect() {
    this.update();
  }

  changed() {
    this.update();
  }

  update() {
    this.programPanelTargets.forEach((panel) => {
      const program = this.programTargets.find((radio) => panel.contains(radio));
      const programOptions = this.programOptionsTargets.find((options) =>
        panel.contains(options)
      );

      const isActive = program && program.checked;

      if (!programOptions) return;

      programOptions.hidden = !isActive;

      programOptions
        .querySelectorAll("input, select, textarea")
        .forEach((el) => {
          el.disabled = !isActive;

          if (!isActive) {
            if (el.type === "checkbox" || el.type === "radio") {
              el.checked = false;
            } else {
              el.value = "";
            }
          }
        });

      const enterCodeContainer = this.enterCodeContainerTargets.find((container) =>
        panel.contains(container)
      );
      if (enterCodeContainer && !isActive) {
        enterCodeContainer.hidden = true;
      }
    });
  }

  toggleCodeField(event) {
    const financialScholarshipCheckbox = event.target;
    const selectedPanel = financialScholarshipCheckbox.closest(
      '[data-driving-school-student-program-enrollment-form-target="programPanel"]'
    );

    if (!selectedPanel) return;

    const enterCodeContainer = this.enterCodeContainerTargets.find((container) =>
      selectedPanel.contains(container)
    );
    const codeField = this.codeFieldTargets.find((field) => selectedPanel.contains(field));

    if (!enterCodeContainer) return;

    const checked = financialScholarshipCheckbox.checked;

    enterCodeContainer.hidden = !checked;

    if (!checked && codeField) {
      codeField.value = "";
    }
  }
}